import { supabase } from "@/infrastructure/supabase/client";
import type { Priority, TaskRow, TaskStatus } from "@/infrastructure/supabase/database.types";

export interface TaskFilters {
  status?: TaskStatus;
  priority?: Priority;
  assigneeId?: string;
  phaseId?: string;
}

export const tasksRepository = {
  async list(filters: TaskFilters = {}): Promise<TaskRow[]> {
    let q = supabase
      .from("tasks")
      .select("*")
      .order("due_date", { ascending: true, nullsFirst: false })
      .order("created_at", { ascending: false });
    if (filters.status) q = q.eq("status", filters.status);
    if (filters.priority) q = q.eq("priority", filters.priority);
    if (filters.assigneeId) q = q.eq("assignee_id", filters.assigneeId);
    if (filters.phaseId) q = q.eq("phase_id", filters.phaseId);
    const { data, error } = await q;
    if (error) throw error;
    return data ?? [];
  },

  async byId(id: string): Promise<TaskRow | null> {
    const { data, error } = await supabase.from("tasks").select("*").eq("id", id).maybeSingle();
    if (error) throw error;
    return data;
  },

  async create(input: Omit<TaskRow, "id" | "created_at" | "updated_at">): Promise<TaskRow> {
    const { data, error } = await supabase.from("tasks").insert(input).select("*").single();
    if (error) throw error;
    return data;
  },

  async update(id: string, patch: Partial<TaskRow>): Promise<TaskRow> {
    const { data, error } = await supabase
      .from("tasks")
      .update(patch)
      .eq("id", id)
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase.from("tasks").delete().eq("id", id);
    if (error) throw error;
  },
};
